const templateMap = {
  trivia: { friendlyName: 'Classic Trivia', moduleName: 'trivia' },
  prediction: { friendlyName: 'Prediction Moment', moduleName: 'trivia' },
  picks: { friendlyName: 'Picks', moduleName: 'trivia' },
  swin: { friendlyName: "Scratch N'Win", moduleName: 'swin' },
  brackets: { friendlyName: 'Brackets', moduleName: 'brackets' },
};

export const getTemplateFriendlyType = type =>
  (templateMap[type] || {}).friendlyName || null;

export const getTemplateModuleName = type => (templateMap[type] || {}).moduleName || null;

export const getTemplateTypes = () => {
  const types = [];

  for (const key in templateMap) {
    types.push({ text: templateMap[key].friendlyName, value: key });
  }

  return types;
};
